<template>
  <li class="nav-item">
    <router-link :to="path" :exact="path === '/'" class="nav-link" active-class="active" :class="activeClass">
      <div class="d-flex align-items-center gutters-xs">
        <slot></slot>
      </div>
    </router-link>
  </li>
</template>

<script>
// https://github.com/vuejs/vue-router/blob/dev/src/util/route.js#L115
const trailingSlashRE = /\/?$/

function queryIncludes (current, target) {
  for (const key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0
  )
}

export default {
  props: ['path', 'additionalActivePaths'],
  computed: {
    // By default the router-link will be active if the `to` prop matches the route
    // The prop `additionalActivePaths` allows to provide additional paths that trigger the active class
    activeClass: function() {
      let activeClass = ''

      // Basic vue router-link active check
      let active = isIncludedRoute(this.$route, this.$router.resolve(this.path).route)

      // Additional active paths
      if (this.additionalActivePaths &&
          this.additionalActivePaths.some(path => isIncludedRoute(this.$route, this.$router.resolve(path).route))) {
        active = true
      }

      return active ? 'active' : null
    }
  }
}
</script>